var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11116 1.35315C3.46404 1.35315 1.31738 3.47775 1.31738 6.09899C1.31738 8.21497 2.15629 13.2369 10.4141 18.3136C10.562 18.4036 10.7318 18.4512 10.9049 18.4512C11.0781 18.4512 11.2479 18.4036 11.3958 18.3136C19.6536 13.2369 20.4925 8.21497 20.4925 6.09899C20.4925 3.47775 18.3459 1.35315 15.6987 1.35315C13.0516 1.35315 10.9049 4.22942 10.9049 4.22942C10.9049 4.22942 8.75829 1.35315 6.11116 1.35315Z",
    stroke: "black",
    strokeOpacity: 0.75,
    strokeWidth: 2.45405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLike);
export default __webpack_public_path__ + "static/media/product_like.092615365582ca0049d60e1e75f0c185.svg";
export { ForwardRef as ReactComponent };